// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GameController from "./game_controller"
application.register("game", GameController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PresenceInvitesController from "./presence_invites_controller"
application.register("presence-invites", PresenceInvitesController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)
